var exports = {
  "i": "xaee3c4fa--a247e1--wrapper",
};

module.exports = exports;
